var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-view',{on:{"request-export":_vm.requestExport,"request-import":_vm.requestImport}}),_c('setting-import-modal',{ref:"settingImportModal",on:{"import-file-upload":_vm.importFileUpload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }